import { en } from './en';
import { ja } from './ja';

export const locales = { en, ja };
// Japanese is the product's primary market. English remains fully supported and is
// selectable via the header toggle (see components/LanguageToggle.jsx).
export const defaultLanguage = 'ja';
export const supportedLanguages = ['en', 'ja'];
